import React from 'react';
import { Section } from './ui/Section';
import { Highlight } from './ui/Highlight';
import { XCircle, CheckCircle } from 'lucide-react';
export function Problem() {
  return <>
      <Section className="bg-surface/30 border-y border-white/5" data-id="element-100">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-101">
          <div data-id="element-102">
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-6" data-id="element-103">
              Este PDF es lo contrario a "inspiración".
            </h2>
            <p className="text-lg text-gray-300 mb-6" data-id="element-104">
              No te da ideas. Te quita decisiones. En 7 días vas a salir con:
            </p>
            <ul className="space-y-4" data-id="element-105">
              {['Una oferta simple que se entiende en 15 segundos', '3 muestras visibles sin portfolio previo', '20 mensajes enviados con guion (sin improvisar)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-106">
                  <CheckCircle className="text-primary w-6 h-6 shrink-0 mt-0.5" data-id="element-107" />
                  <span className="text-lg font-medium" data-id="element-108">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-black/50 p-8 border border-white/10 rounded-sm" data-id="element-109">
            <h3 className="text-xl font-bold text-white mb-4 uppercase tracking-wider" data-id="element-110">
              La Promesa (Sin Humo)
            </h3>
            <p className="text-gray-300 leading-relaxed" data-id="element-111">
              Si hoy sabes usar ChatGPT "más o menos"… pero no tienes clientes…
              este sistema está diseñado para una sola cosa:
              <br data-id="element-112" />
              <br data-id="element-113" />
              <Highlight data-id="element-114">
                Conseguir tu primer cliente sin volverte creador de contenido,
                sin "marca personal" y sin esperar meses.
              </Highlight>
            </p>
          </div>
        </div>
      </Section>

      <Section data-id="element-115">
        <h2 className="text-4xl md:text-5xl font-display font-bold mb-12 text-center" data-id="element-116">
          EL PROBLEMA REAL <br data-id="element-117" />
          <span className="text-gray-500 text-2xl md:text-3xl font-normal" data-id="element-118">
            (El que nadie te dice)
          </span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-119">
          <div className="space-y-6 text-lg text-gray-300" data-id="element-120">
            <p data-id="element-121">
              No estás perdiendo por falta de talento. Estás perdiendo por falta
              de:
            </p>
            <ul className="space-y-3 pl-4 border-l border-red-500/50" data-id="element-122">
              <li className="flex items-center gap-3" data-id="element-123">
                <XCircle className="text-red-500 w-5 h-5" data-id="element-124" /> Un micro-nicho
                comprable
              </li>
              <li className="flex items-center gap-3" data-id="element-125">
                <XCircle className="text-red-500 w-5 h-5" data-id="element-126" /> Una oferta que no
                se confunda
              </li>
              <li className="flex items-center gap-3" data-id="element-127">
                <XCircle className="text-red-500 w-5 h-5" data-id="element-128" /> Una muestra que se
                vea en 3 segundos
              </li>
              <li className="flex items-center gap-3" data-id="element-129">
                <XCircle className="text-red-500 w-5 h-5" data-id="element-130" /> Un guion para
                enviar mensajes sin pensar
              </li>
            </ul>
            <p className="font-medium text-white pt-4" data-id="element-131">
              Entonces haces lo que hace todo el mundo: te dices "mañana", y hoy
              consumes otro video.
            </p>
          </div>

          <div className="relative" data-id="element-132">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent blur-3xl opacity-30" data-id="element-133"></div>
            <div className="relative bg-surface border border-white/10 p-8 h-full flex flex-col justify-center" data-id="element-134">
              <h3 className="text-2xl font-bold mb-4" data-id="element-135">
                Por qué lo que probaste no funcionó
              </h3>
              <div className="space-y-4 text-gray-400" data-id="element-136">
                <p data-id="element-137">
                  • Los cursos te enseñan "formas de ganar dinero", pero no te
                  dan un sistema de ejecución diario.
                </p>
                <p data-id="element-138">• Los prompts no son una oferta.</p>
                <p data-id="element-139">
                  • "Ser freelancer" sin un entregable claro es como abrir una
                  tienda sin letrero.
                </p>
                <p className="text-white font-medium border-t border-white/10 pt-4 mt-4" data-id="element-140">
                  Y lo peor: cuando no hay estructura, tu mente elige lo que
                  duele menos. Y vender… duele.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>;
}